import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import { TablePluginOptions } from '../types';
import { renderElementTablePDF } from './renderElementTablePdf';

export const TablePDFPlugin = (opts: TablePluginOptions = {}): SlatePlugin => {
  return {
    renderElement: renderElementTablePDF(opts),
  };
};
